import { useFormatter } from "next-intl";

export const DATE_FORMATS = {
  long: {
    weekday: "long",
    day: "numeric",
    month: "long",
  },
  longWithYear: {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  },
  shortWithYear: {
    day: "numeric",
    month: "short",
    year: "numeric",
  },
  dayMonthShort: {
    day: "numeric",
    month: "short",
  },
} as const satisfies Record<string, Intl.DateTimeFormatOptions>;

export type TDateFormat = keyof typeof DATE_FORMATS;

export const useDateFormatter = (): (
  value: Date | number,
  dateFormat?: TDateFormat,
) => string => {
  const format = useFormatter();

  return (value, dateFormat = "long") => (
    format.dateTime(value, DATE_FORMATS[dateFormat])
  );
};
